import {
    AppBar,
    Box,
    Container,
    Typography,
    Button
} from '@mui/material';

import { Outlet } from 'react-router-dom';
import { AppFooter } from './routes/footer';
import { Link } from 'react-router-dom';
import { theme } from './theme';

import { HeaderComponents } from 'routes/header';


export const ErrorPage = () => {

    return (
        <Box>
            <AppBar position='static'>
                <Container maxWidth='xl'>
                    <HeaderComponents />
                    <Box sx={{
                        padding: theme.spacing(4),
                        minHeight: '40vh',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: theme.spacing(3)
                    }}>
                        <Typography
                            variant='h2'
                            sx={{
                                fontWeight: 800,
                                textTransform: 'uppercase',
                                textAlign: 'center'
                            }}
                        >
                            Page not found ⚠️
                        </Typography>
                        <Typography
                            variant='h5'
                            sx={{ textAlign: 'center' }}
                        >
                            Apologies, but the page you were looking for wasn't found.
                        </Typography>
                        <Button
                            component={Link}
                            to="/"
                            variant="contained"
                            size="large"
                            sx={{
                                marginTop: theme.spacing(2),
                                minWidth: 200
                            }}
                        >
                            Back to Home
                        </Button>
                    </Box>

                </Container>
            </AppBar>
            <Outlet />
            <AppFooter />
        </Box>
    );
};
